import React, { useState, useEffect, createRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import TR from './../../Trans';
import { checkIfMobile } from '../../services/screen';
import { ReactComponent as MuvikaSongbookLogo } from './../../assets/songbook.svg';
import { ReactComponent as MuvikaSongbookLogoInv } from './../../assets/songbook-inv.svg';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { useLocalStorage } from '../../services/useLocalStorage';
import muvikaAttrs from './../../attrs';
import Toolbar from '@mui/material/Toolbar';
import { useMediaQuery } from 'react-responsive';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchField from './../items/SearchField';
import { Views } from './../../enums/enums';
import navigationStore from '../.././stores/navigation';
import searchStore from './../../stores/search';
import messageStore from './../../stores/message';
import settingsStore from '../../stores/settings';
import performanceStore from './../../stores/performance';
import songbookSessionStore from './../../stores/songbookSession';
import accountStore from '../../stores/account';
import environmentStore from './../../stores/environment';
import playerStore from './../../stores/player';

function SongbookNavBar(props) {
  const itemsOnPage = 25;
  const sessionToken = songbookSessionStore((state) => state.sessionToken);
  const isSongbookPublicMode = songbookSessionStore((state) => state.isSongbookPublicMode);
  const isSongbookPublicBoothMode = songbookSessionStore((state) => state.isSongbookPublicBoothMode);
  const logout = songbookSessionStore((state) => state.logout);
  const search = searchStore((state) => state.search);
  const goToView = navigationStore((state) => state.goToView);
  const searchQuery = searchStore((state) => state.searchQuery);
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const setError = messageStore((state) => state.setError);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const session = songbookSessionStore((state) => state.session);
  const searchNavBarInputRef = searchStore((state) => state.searchNavBarInputRef);

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const handleLogOut = () => {
    logout();
  };

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  let [changedSearchQuery, setChangedSearchQuery] = useState(searchQuery);

  const handleSearchQueryChange = (e) => {
    setChangedSearchQuery(e.target.value);
  };

  const onSearch = () => {
    if (changedSearchQuery.length > 1) {
      setSearchQuery(changedSearchQuery);
      search(sessionToken, itemsOnPage);
      goToView(Views.Search);
      if (document.activeElement) {
        document.activeElement.blur();
      }
    } else {
      setError(sessionToken, 0, TR.cm_seach_text_too_short);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  const handleSearch = (event) => {
    onSearch();
  };

  const renderLogOutButton = () => {
    if (settings) {
      if (!isSongbookPublicMode && !isSongbookPublicBoothMode) {
        return <Box>
          <IconButton
            className="muvika-navbar-icon"
            size="large"
            edge="end"
            color="inherit"
            component="label"
            onClick={() => handleLogOut(true)}
          >
            <CloseIcon />
          </IconButton>
        </Box>;
      }
    }
  };

  const renderSongbookCode = () => {
    if (settings) {
      return <span className="muvika-songbook-navbar-stack-code">{settings.sb_code}</span>;
    }
  };

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-songbook-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaSongbookLogo className="muvika-logo-songbook-svg" />;
    } else {
      return <MuvikaSongbookLogoInv className="muvika-logo-songbook-svg" />;
    }
  };

  const renderOfficeName = () => {
    if (session.account) {
      if (session.account.office_name) {
        if (session.account.office_name.length > 0) {
          return <Tooltip title={session.account.office_name}>
            <span className="muvika-songbook-navbar-stack-office">
              {session.account.office_name}
            </span>
          </Tooltip>;
        }
      }
      return <Tooltip title={session.account.firstname}>
        <span className="muvika-songbook-navbar-stack-office">
          {session.account.firstname}
        </span>
      </Tooltip>;
    }
  };

  const renderSongbookInfo = () => {
    return <Stack className="muvika-songbook-navbar-info" spacing={0}>
      {renderOfficeName()}
      {renderSongbookCode()}
    </Stack>;
  };

  const renderSearchBar = () => {
    if (!checkIfMobile()) {
      return <SearchField isSongbook={true} id="muvika-search-songbook" onref={searchNavBarInputRef} isNavBar={true} className="muvika-songbook-app-bar-search-field" value={searchQuery} onSearchQueryChange={handleSearchQueryChange} onSearch={handleSearch} onKeyDown={handleKeyDown} />;
    }
  };

  const renderCenterBar = () => {
    if (!checkIfMobile()) {
      return <Box className="muvika-songbook-navbar-left">
        <Stack direction="row" spacing={2} >
          {renderSearchBar()}
        </Stack>
      </Box>;
    }
  };

  return (
    <AppBar
      position="fixed"
      className="muvika-app-bar"
      sx={{ background: "var(--back-color) !important" }}
    >
      <Toolbar>
        <Box className="muvika-app-bar-logo-box">
          {renderLogo()}
        </Box>
        {renderCenterBar()}
        <Box className="muvika-navbar-right">
          <Stack direction="row" spacing={1} justifyContent="right">
            {renderSongbookInfo()}
            {renderLogOutButton()}
          </Stack>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default SongbookNavBar;
